import React from 'react';
import { Link } from 'react-router-dom';
import about from '../../images/about/team.jpg';

const About = props => {
	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='pt-[120px] pb-[100px]'>
			<div className='wraper'>
				<div className='grid grid-cols-12 items-top gap-3'>
					<div className='col-span-6 md:col-span-12'>
						<div className='relative mb-[20px]'>
							<div className=" relative max-w-[520px] before:absolute before:bg-[#c0b596] before:w-full before:h-full before:content-[''] before:-z-10 before:left-[-20px] before:top-[-20px] ">
								<img className='w-full' src={about} alt='' />
							</div>
						</div>
					</div>
					<div className='col-span-6 md:col-span-12'>
						<div className='mb-[20px]'>
							<h2 className='text-[#282e3f] text-[32px] mb-[20px]'>À propos de nous</h2>
							<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
								Le cabinet d'avocats qu'il vous faut.
							</p>
							<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
								Vous aimeriez trouver un avocat qui cherche à vous comprendre, qui vous livre des
								explications claires, qui est orienté vers les solutions, qui vous conseille de façon
								raisonnable avec compétence et qui, si nécessaire, plaidera votre cause avec conviction
								?
							</p>
							<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
								Vous le trouverez chez nous.
							</p>
							<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
								GAVA-<i>Lex</i> est un cabinet d'avocats à taille humaine, conduit par deux associés qui
								combinent dynamisme et expérience, entourés par une solide équipe.
							</p>
							<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
								Le cabinet principal est situé en plein cœur de Charleroi, à proximité du palais de
								justice, avec une antenne à Bruxelles (Watermael-Boitsfort) et possibilité de vous
								recevoir à Mont-sur-Marchienne ou Gerpinnes.
							</p>
							<p className='text-[#666] text-[15px] leading-[28px] mb-[30px]'>
								Même une bonne cause a besoin d'un bon secours. Vous avez intérêt à faire appel à nous
								dans nos matières de prédilection que vous retrouverez ci-après.
							</p>
							<div className='mb-[50px] col:mb-[20px]'>
								<Link
									onClick={ClickHandler}
									to='/equipe'
									className='bg-[#c0b596] cursor-pointer text-[16px] font-semibold text-white px-[38px] py-[10px]  capitalize inline-block mt-[6px] transition ease-in-out duration-300 hover:bg-[#d4c291]
                                col:mb-[5px] col:mt-[15px] col:text-[15px] col:px-[18px] col:py-[8px] 
                                '
								>
									En savoir plus ...
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default About;
